export enum ROLE {
  "Super Admin" = 1,
  "Security Firm Admin" = 2,
  "Security Firm Sub Admin" = 3,
  "Responsible Person" = 4,
  "Shift Supervisor" = 5,
  "Arm Response Officer" = 6,
  "Control Room" = 7,
}
